import { ModuleFE_OrderConfiguration } from './ModuleFE_OrderConfiguration.js';
export const ModulePackFE_OrderConfiguration = [ModuleFE_OrderConfiguration];
//# sourceMappingURL=module-pack.js.map